import type { SVGProps } from "react";

import logoAnthropic from "../../generated/images/LogoAnthropic";
import logoGemini from "../../generated/images/LogoGemini";
import logoGloq from "../../generated/images/LogoGroq";
import logoOpenai from "../../generated/images/LogoOpenai";
import logoPreplexity from "../../generated/images/LogoPreplexity";
import logoXai from "../../generated/images/LogoXai";
import logoCohere from "../../generated/images/LogoCohere";
import logoHuggingFace from "../../generated/images/LogoHuggingface";
import logoWartsonx from "../../generated/images/LogoWatsonx";
import logoNscale from "../../generated/images/LogoNscale";
import logoBedrock from "../../generated/images/LogoBedrock";
import logoAzure from "../../generated/images/LogoAzure";

export type SVGTag = (props: SVGProps<SVGSVGElement>) => JSX.Element;

const files: { [key: string]: SVGTag } = {
  "logo-anthropic": logoAnthropic,
  "logo-gemini": logoGemini,
  "logo-gloq": logoGloq,
  "logo-openai": logoOpenai,
  "logo-perplexity": logoPreplexity,
  "logo-xai": logoXai,
  "logo-cohere": logoCohere,
  "logo-huggingface": logoHuggingFace,
  "logo-watsonx": logoWartsonx,
  "logo-nscale": logoNscale,
  "logo-bedrock": logoBedrock,
  "logo-azure": logoAzure,
};

export const getSVG = (name?: string): SVGTag | undefined =>
  name === undefined ? undefined : files[name];
